import { CanActivateFn } from '@angular/router';

import { LangService } from '../services/lang.service';
import { inject } from '@angular/core';

export const languageCheckGuard: CanActivateFn = (route, state) => {
  const langService = inject(LangService);

  const langFromUrl = route.params.lang?.toLowerCase();

  const langFound = langService.getAvailableLangs().find(lang => lang.locale.toLowerCase() === langFromUrl);

  return !!langFound;
};
